import React from 'react'

function HeaderComponent({ name, totalRecords }) {

    const customStyles = {
        header: {
            borderRadius: '4px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            marginBottom: '8px',
            backgroundColor: 'white'
        },
        text: {
            display: 'flex',
            fontSize: '20px',
            padding: '4px 8px',
            fontWeight: 'bold'
        }
    }

    return (
        <div style={customStyles.header}>
            <span style={customStyles.text}>
                {name} {totalRecords ? `(${totalRecords})` : ""}
            </span>
        </div>
    )
}

export default HeaderComponent